var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRtVerificationLinkIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38892 6.27734L6.27764 9.38862",
    stroke: "#181D27",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61114 4.1667L7.83337 2.94447C9.18341 1.59442 11.3723 1.59442 12.7223 2.94446C14.0723 4.29451 14.0723 6.48335 12.7223 7.83339L11.5001 9.05563",
    stroke: "#181D27",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05561 11.4993L7.83338 12.7216C6.48334 14.0716 4.29449 14.0716 2.94445 12.7216C1.59441 11.3715 1.59441 9.18266 2.94445 7.83262L4.16668 6.61039",
    stroke: "#181D27",
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRtVerificationLinkIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RT_verification_link_icon.20572df0aa4d3670c513756091e71d59.svg";